/**
 * Quiz API Service
 * Handles all quiz-related API calls
 */

import quizApiInstructorMixin from './quizApi/quizApiInstructor';
import quizApiStudentMixin from './quizApi/quizApiStudent';
import quizApiTimeUtilsMixin from './quizApi/quizApiTimeUtils';

class QuizApiService {}

Object.assign(QuizApiService.prototype, quizApiInstructorMixin);
Object.assign(QuizApiService.prototype, quizApiStudentMixin);
Object.assign(QuizApiService.prototype, quizApiTimeUtilsMixin);

const quizApiService = new QuizApiService();
export default quizApiService;
